import { Component, input, effect } from '@angular/core';
import { ResponsiveVisibility } from '../../responsive-visibility';
import { IPDFViewerApplication } from '../../options/pdf-viewer-application';
import { PDFNotificationService } from '../../pdf-notification-service';

@Component({
    selector: 'pdf-move-up',
    templateUrl: './pdf-move-up.component.html',
    styleUrls: ['./pdf-move-up.component.css'],
    standalone: false
})
export class PdfMoveUpComponent {
  public showMoveUpButton = input<ResponsiveVisibility>(true);

  // #2818 modified by ngx-extended-pdf-viewer
  public disable = input<boolean>(false);
  // #2818 end of modification by ngx-extended-pdf-viewer

  private PDFViewerApplication: IPDFViewerApplication | undefined;

  constructor(notificationService: PDFNotificationService) {
    effect(() => {
      this.PDFViewerApplication = notificationService.onPDFJSInitSignal();
    });
  }

  public movePageUp = () => {
    if (this.PDFViewerApplication) {
      const currentPage = this.PDFViewerApplication.page;
      // #3216 eventBus may be undefined during destroy/recreate transitions of the PDFViewerApplication singleton.
      this.PDFViewerApplication.eventBus?.dispatch('movePageUp', {
        source: { pageNumber: currentPage }
      });
    }
  };
}
